import { SVGProps, Ref, forwardRef } from 'react';

export const MagnifierFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11 1C3.5 1 1 6 1 11s2.5 10 10 10c2.96 0 5.142-.779 6.698-2.03l4.026 4.026 1.272-1.272-4.034-4.035C20.415 15.837 21 13.42 21 11c0-5-2.5-10-10-10"
                fill="currentColor"
            />
        </g>
    </svg>
));
MagnifierFilledSize24Glyph.displayName = 'MagnifierFilledSize24Glyph';
